export enum Language {
	// according to the table "jv"
	Cz = 1,
	Ru = 2,
	En = 3,
	De = 4,
	Ua = 5,
	Su = 6,
}
